import { updatePrice } from "./displayPrices";

const Products = {
  
  // Retorna os dados de um produto a partir do ID
  getData: async function (id) {
    try {
      const response = await fetch(`/produto/preco/${id}`, {
        method: 'GET',
        headers: {
          'Accept': 'application/json'
        }
      })

      if (!response.ok) throw new Error(`Erro ao buscar dados: ${response.statusText}`)
      return await response.json()

    } catch (error) {
      console.error(`Erro ao buscar os dados do produto com ID ${id}: `, error)
      return null
    }
  },

  // Inicializa os produtos (variantes/preços) da página
  init: function (elements) {
    const products = elements ? elements : document.querySelectorAll('[data-product-box]:not([data-product-unique-id])');
  
    if (products.length)
      products.forEach((product) => {
  
        const observer = new IntersectionObserver(async (entries) => {
          if (entries[0].isIntersecting) {
  
            const productEl = entries[0].target;
            const productId = productEl.getAttribute('data-product-box');
            const purchaseEl = productEl.querySelector('[data-product-purchase]');
  
            if (productId !== '' && productId !== null) {
              
              const productData = await Products.getData(productId);
  
              // Popula o array de variantes
              window.productVariants[`${productId}`] = productData.variants;

              // Inicia o purchase das variantes
              let event = new CustomEvent('vnda:variants-init');
              if (purchaseEl) purchaseEl.dispatchEvent(event);

              // Dispara evento para atualizar as imagens com sku no main slider
              const productVariantsEvent = new CustomEvent('vnda:product-variants-populated');
              window.dispatchEvent(productVariantsEvent);
  
              // Inicia o preço do produto
              let priceEl = productEl.querySelector('[data-update-price]');
              if (priceEl) {
                if (priceEl.innerHTML == '') updatePrice(productData, priceEl);
              } else {
                console.error(`Produto ID '${productId}' não possui elemento de preço`);
              }
            }
  
            observer.disconnect();
          }
        }, { threshold: 0.1 });
  
        observer.observe(product);
      });
  },
}

export default Products;
